import { createAsyncThunk } from "@reduxjs/toolkit";
import routeHistoryApi from "./api";

export const getRouteHistoryList = createAsyncThunk(
  "routes-history/get/loading",
  async (data) => {
    return routeHistoryApi.getList(data);
  }
);
